import { Query } from '@apollo/client/react/components';
import React from 'react';

import { Messages } from '../../../../../gen-src/Localize';
import { DatabaseTableQuery, DatabaseTableQueryVariables, DatabaseTableDocument } from '../../../../../gen-src/queries';
import {
  CenteredFadeInSpinner,
  CenteredMessage,
} from '../../../data-catalog-shared';
import { RenderQueryResult } from '../renderQueryResult';
import { createRenderDataWithErrorFunction, renderError, renderNoData } from '../widgets/ErrorMessageWidgets';

type DatabaseTable = Unpacked<DatabaseTableQuery['databaseTables']>;

export type TableQueryWrapperProps = {
  readonly tableId: string;
  readonly children: (result: DatabaseTable) => React.ReactNode;
};

export const TableQueryWrapper = (props: TableQueryWrapperProps) => {

  const renderTableData = React.useCallback(
    (data: DatabaseTableQuery): React.ReactNode => {
      const table = data.databaseTables ? data.databaseTables[0] : null;
      if (table) {
        return props.children(table);
      } else {
        return <CenteredMessage message={Messages.ErrorItemNotFound()} />;
      }
    },
    [props]
  );

  return (
    <Query<DatabaseTableQuery, DatabaseTableQueryVariables>
      query={DatabaseTableDocument}
      variables={{ tableId: props.tableId }}
    >
      {result => <RenderQueryResult result={result} renderers={{
        renderLoading: () => <CenteredFadeInSpinner />,
        renderData: renderTableData,
        renderNoData: renderNoData,
        renderDataWithError: createRenderDataWithErrorFunction(renderTableData),
        renderError: renderError,
      }} />}
    </Query>
  );
}
